module.exports = __webpack_public_path__ + "assets/img/a9f9-pa.svg";